import { render } from "./FormSubmitComponent.vue?vue&type=template&id=a79d7590&scoped=true"
import script from "./FormSubmitComponent.vue?vue&type=script&lang=js"
export * from "./FormSubmitComponent.vue?vue&type=script&lang=js"

import "./FormSubmitComponent.vue?vue&type=style&index=0&id=a79d7590&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79d7590"]])

export default __exports__